import { render, staticRenderFns } from "./ReseveDetailPopup.vue?vue&type=template&id=5d7b552d&scoped=true&"
import script from "./ReseveDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ReseveDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReseveDetailPopup.vue?vue&type=style&index=0&id=5d7b552d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b552d",
  null
  
)

export default component.exports